import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';

export const templateExclusionListSelector = document.createElement('template');

templateExclusionListSelector.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-enum-filter id="exclusionListSelectorDropdown"> </gz-enum-filter>
  </div>
`;
